export const selectEquipmentCategory = {
    bindings: {
        identifier: '@'
    },
    template: require('./select-equipment-category.html'),
    controller: 'SelectEquipmentCategoryController'
};
